/* todo @deprecated */
import { FunctionComponent } from 'react';
import classnames from 'classnames';

import styles from './ButtonLink.module.sass';

// Make all buttons on screen consistent. Do not allow random values for the size property.
export enum ButtonSize {
    Small = 'Small',
    Medium = 'Medium',
    Large = 'Large',
    ExtraLarge = 'ExtraLarge',
}

export interface ButtonLinkProps {
    text: string;
    disabled?: boolean;
    onClick?: () => void;
    browser?: 'desktop' | 'mobile'; // todo
    bgColor?: string;
    textColor?: string;
    size?: ButtonSize;
    href?: string;
}

const ButtonLink: FunctionComponent<ButtonLinkProps> = ({
    text,
    disabled,
    browser = 'desktop',
    size = ButtonSize.Medium,
    bgColor = 'white',
    textColor = 'black',
    href,
    onClick = () => null,
}) => {
    const className = classnames(styles.btn, styles[`size${size}`], {
        [styles.disabled]: disabled,
    });
    const compStyle = { backgroundColor: bgColor, color: textColor };
    return href ? (
        <a className={className} href={href} style={compStyle}>
            {text}
        </a>
    ) : (
        <div className={className} style={compStyle} onClick={onClick}>
            {text}
        </div>
    );
};

export default ButtonLink;
